var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ml_detail"},[_c('a-avatar',{staticClass:"ml_back_page",attrs:{"icon":"rollback","size":"large"},on:{"click":_vm.goBack}}),(_vm.orderObj)?_c('orderDetail',{attrs:{"orderObj":_vm.orderObj},on:{"onSave":_vm.onUploadSave}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }